import { FlagUsa, FlagSpain, FlagUkraine } from '@/assets';
import { Language } from '@/api/types';
import { cn } from '@/lib/utils';

// Russian is deliberately absent: 123jobs offers Ukrainian alongside it, and the
// language chooser has never shown a Russian flag. `Partial` keeps that in the
// type, so the flagless branch below cannot be forgotten.
const LANGUAGE_FLAG: Partial<Record<Language, typeof FlagUsa>> = {
  english: FlagUsa,
  spanish: FlagSpain,
  ukrainian: FlagUkraine,
};

interface LanguageFlagProps {
  language: Language;
  className?: string;
}

export function LanguageFlag({ language, className }: LanguageFlagProps) {
  const Flag = LANGUAGE_FLAG[language];
  if (!Flag) return null;

  // Decorative: the short code next to it carries the meaning, and the
  // <select> that wraps this control has its own aria-label.
  return (
    <Flag
      data-testid="language-flag"
      className={cn('size-4 shrink-0 rounded-full', className)}
      aria-hidden
    />
  );
}
